export function squareGridColumns(itemCount) {
  if (!itemCount || itemCount <= 0) return 0;
  return Math.ceil(Math.sqrt(itemCount));
}

export function squareGridRowCount(itemCount) {
  const columns = squareGridColumns(itemCount);
  if (columns === 0) return 0;
  return Math.ceil(itemCount / columns);
}

export function chunkIntoSquareGrid(items) {
  const list = items || [];
  const columns = squareGridColumns(list.length);
  if (columns === 0) return [];
  const rows = [];
  for (let index = 0; index < list.length; index += columns) {
    rows.push(list.slice(index, index + columns));
  }
  return rows;
}
